const toggleMenu = () => {
    const toggleBtn = document.querySelector('#menu-mobile-js-toggle')
    const menu = document.querySelector('#menu-mobile-js')

    toggleBtn.addEventListener('click', () => {
        if( toggleBtn.classList.contains('active') ) {
            toggleBtn.classList.remove('active')
            menu.classList.remove('active')
        } else {
            toggleBtn.classList.add('active')
            menu.classList.add('active')
            const submenuItems = menu.querySelectorAll(
                '.menu-item-drop, #Search, button'
            );
            submenuItems.forEach(function(item){
            item.tabIndex = 0
            })
                }
            });
            document.addEventListener('keydown', function(event) {
            const mobileMenu = document.querySelector('#menu-mobile-js');
            const activeElement = document.activeElement;
            if (event.key === 'Escape' && toggleBtn.classList.contains('active') && (mobileMenu.contains(activeElement) || activeElement == toggleBtn)) {
            const mobileMenu = document.querySelector('#menu-mobile-js');
            toggleBtn.click();
            toggleBtn.focus();
            const submenuItems = mobileMenu.querySelectorAll(
                '.menu-item-drop, #Search, button'
            );
            submenuItems.forEach(function(item){
                item.tabIndex = -1
            })
        }
    })
}

const closeWhenScroll = () => {
    window.addEventListener('scroll', () => {
         closeSubmenus()
        }
    )   
}

var closeSubmenus = function closeSubmenus() {
  var submenus = document.querySelectorAll('.submenu.active');
  var menuItems = document.querySelectorAll('.menu-item.active');
  var submenuItems = document.querySelectorAll('.submenu-item');
  submenus.forEach(function (item) {
    item.classList.remove('active');
  });
  menuItems.forEach(function (item) {
    item.classList.remove('active');
  });
  submenuItems.forEach(function(item){
    item.tabIndex = -1
  })
};

const initMenu = () => {
    closeWhenScroll()
    toggleMenu()
    const menuItems = document.querySelectorAll('.menu-item-drop')

    menuItems.forEach((menuItem) => {
        menuItem.addEventListener('click', async (e) => {
            const link =  e.target
            
            if (link.getAttribute('href') == '#') {
                e.stopPropagation()
                e.preventDefault()
            }
            
            const submenu = menuItem.parentNode.querySelector('.submenu')

            if (!submenu) { return }

            if (submenu.classList.contains('active') && menuItem.parentNode.classList.contains('active')) {
                submenu.classList.remove('active')
                menuItem.parentNode.classList.remove('active')
            } else {
                await closeSubmenus()
                submenu.classList.add('active')
                menuItem.parentNode.classList.add('active')
                var submenuItems = submenu.querySelectorAll('.submenu-item');
                submenuItems.forEach(function(item){
                    item.tabIndex = 0
                })
            }
        })
    })
}

export { initMenu, closeSubmenus }